import { AuthorAvatar } from "@/app/components/Avatar"
import { Table, TableBody, TableCell, TableRow } from "@/components/ui/table"
import { formatTimeAgo } from "@/lib/utils/format"
import { User } from "@/types/users"

export type Supporter = {
  avatar: Partial<User>
  lastTx: number
  percentage: string
}

type Props = {
  supporters: Supporter[]
  isMinimal?: boolean
}

export default function SupporterTable({ supporters, isMinimal }: Props) {
  return (
    <Table>
      <TableBody>
        {supporters.map((supporter, i) => (
          <TableRow
            key={`${supporter.avatar.id}-${i}`}
            className="flex items-center"
          >
            <TableCell
              className={`flex items-center gap-3 ${isMinimal ? "w-5/6" : "w-3/6"}`}
            >
              <AuthorAvatar size={32} user={supporter.avatar} />

              <div className="text-sm text-foreground font-normal">
                {supporter.avatar.displayName?.fullName ||
                  supporter.avatar.authorName ||
                  "Anonymous"}
              </div>
            </TableCell>
            {!isMinimal && (
              <TableCell className="w-2/6 text-sm text-muted-foreground">
                {formatTimeAgo(new Date(supporter.lastTx))}
              </TableCell>
            )}
            <TableCell className="w-1/6 text-right text-sm text-muted-foreground">{`${supporter.percentage}%`}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
